<template>
<el-drawer
  :withHeader="false"
  :visible.sync="show">
  <div class="drawer-content" v-if="product">
    <i class="el-icon-close close-icon" @click="show = false"></i>
    <div class="product-image">
      <el-image class="image" :src="product.mainImage" v-if="product.mainImage" fit="cover" :preview-src-list="[product.mainImage]" />
      <img v-else src="../../../../../assets/images/default.png" class="image" />
    </div>
    <!-- 产品信息区域 -->

    <div class="product-info">
      <!-- 直播间信息 -->
      <div class="live-info">
        <img src="../../../../../assets/images/dy.png" class="live-icon" />
        <span class="live-room">{{ product.liveRoomName }}</span>
          {{ product.categoryName }} {{ product.brandName }} {{ product.productName }} {{ product.activityMechanism || '' }}
      </div>
      <div class="expiry-time">
        <div class="label">活动结束时间</div>
        <div class="value">{{ computedTime(product.validEndTime) }}</div>
      </div>
      <div class="flex-row">
        <div class="price">
          爆品限时补贴至
          <span class="value" v-if="product.userRebateStr !== '' || product.userRebatePrice !== null">
          {{ product.userRebateStr }}
          </span>
        </div>
      </div>
      <div class="content-title">分享文案（可编辑）：</div>
      <div class="edit-content" ref="shareTextRef" :contenteditable="true">
        <template v-for="(item, index) in editList">
          <div v-if="checkList.includes(item.key)" :key="index">
          【{{ item.label }}】 {{ componentValue(item) }}
          </div>
        </template>
      </div>
      <div class="items">
        <el-checkbox-group v-model="checkList">
          <el-checkbox class="item" v-for="(item, index) in editList" :key="index" :label="item.key">{{ item.label }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="btns">
        <div class="btn" v-if="product.signalPass" @click="toOrder">立即下单</div>
        <div class="btn" @click="$emit('toOrder')">去报单</div>
        <div class="btn" @click="copyText">复制分享文案</div>
      </div>
    </div>
  </div>
</el-drawer>
</template>
<script>
import moment from 'moment'
import { extractUrls, copyFn } from '@/utils/util'
const editList = [
  {
    label: '商品名称',
    key: 'productName',
    active: true
  },
  {
    label: '直播间',
    key: 'liveRoomName',
    active: true
  }, 
  {
    label: '爆品限时补贴至',
    key: 'userRebateStr',
    filterFn: (val) => (val || 0) + '', // 折
    active: true
  },
  {
    label: '下单链接',
    key: 'signalPass',
    filterFn: (val) => extractUrls(val),
    active: true
  },
  {
    label: '链接失效时间',
    key: 'validEndTime',
    type: 'dateTime',
    active: true
  }
]
export default {
  name: 'M2sBuyDrawer',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
  },
  data () {
    return {
      editList, 
      checkList: editList.map(item => item.key)
    }
  },
  methods: {
    toOrder () {
      if (this.product && this.product.signalPass) {
        window.open(extractUrls(this.product.signalPass))
      }
    },
    copyText() {
      const el = this.$refs.shareTextRef
      if (!el) return
      // 获取纯文本内容，不同div块用换行分隔
      const text = Array.from(el.querySelectorAll('div'))
        .map(div => div.textContent.trim())
        .join('\n')
      copyFn(text, () => {
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      })
    },
    computedTime (date) {
      if (date) {
        return moment(date).format('YYYY/MM/DD HH:mm:ss')
      }
      return '-'
    },
    componentValue(item) {
      return item.type === 'dateTime' && this.product[item.key] ? 
        moment(this.product[item.key]).format('YYYY/MM/DD HH:mm:ss') 
          : item.filterFn ? 
            item.filterFn(this.product[item.key]) 
              : (this.product[item.key] || '') + (item.unit || '')
    }
  }
}
</script>
<style scoped>
.drawer-content {
  padding: 18px;
  position: relative;
}
.close-icon {
  position: absolute;
  left: 8px;
  top: 8px;
  z-index: 10;
  width: 28px;
  height: 28px;
  font-size: 16px;
  line-height: 28px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
}
.product-image {
  width: 100%;
  position: relative;
  padding-top: 100%;
}
.product-image .image {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.product-info {
  padding: 12px;
  padding-bottom: 0;
}

.live-info { 
  line-height: 22px;
  font-size: 18px;
  font-weight: 700;
  height: 44px;
  overflow: hidden;
}

.live-icon {
  margin-top: 1px;
  width: 20px;
  height: 20px;
  margin-right: 4px;
  vertical-align: middle;
  float: left;
}

.live-room {
  border: solid 1px #ff4d4f;
  color: rgba(255, 53, 176, 1);
  line-height: 20px;
  border-radius: 2px;
  font-size: 18px;
  height: 20px;
  overflow: hidden;
  font-weight: bold;
  float: left;
  margin-right: 4px;
  max-width: calc(100% - 22px);
}
.expiry-time {
  display: flex;
  align-items: center;
  padding: 12px 0;
  color: rgba(129, 76, 49, 1);
}
.expiry-time .label {
  height: 16px;
  line-height: 16px;
  font-size: 14px;
  font-weight: bold;
  padding: 0 2px;
  background: linear-gradient(90deg, #FFE3D0 0%, #FFEDCC 100%);
}
.expiry-time .value {
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  padding: 0 2px;
  border: solid 1px rgba(197, 149, 90, 1);
}
.price {
  height: 48px;
  line-height: 48px;
  padding: 0 12px;
  color: rgba(247, 78, 181, 1);
  font-size: 16px;
  background-color: rgba(255, 244, 250, 1);
}
.price .value {
  vertical-align: middle;
  font-weight: 700;
  padding-left: 12px;
  font-size: 32px;
}
.content-title {
  padding: 12px 0 6px 0;
  line-height: 24px;
  font-size: 14px;
  color: #000;
  font-weight: 700;
}
.edit-content {
  height: 132px;
  line-height: 20px;
  padding: 12px;
  font-size: 14px;
  overflow: scroll;
  color: rgba(104, 104, 104, 1);
  border-radius: 12px;
  border: solid 1px rgba(247, 78, 181, 1);
  background-color: rgba(248, 248, 248, 1);
}
.edit-content:focus {
  outline: none;
}
.items {
  padding: 12px 0;
  line-height: 22px;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: rgba(36, 36, 36, 1);
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: rgba(247, 78, 181, 1);
  background-color: rgba(247, 78, 181, 1);
}
.btns {
  display: flex;
}
.btns .btn {
  margin: 0 4px;
  flex: 1;
  border-radius: 8px;
  line-height: 44px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(270deg, #FF38B9 0%, #FF6F85 100%);
}
.btns .btn&:first-child {
  margin-left: 0;
}
.btns .btn&:last-child {
  margin-right: 0;
}
</style>
